"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capsuleSizes = exports.capsuleColours = void 0;
var capsuleColours = {
  YOLK: 'yolk',
  FOX: 'fox',
  DENIM: 'denim',
  OINK: 'oink',
  MIAMI: 'miami',
  KIDNEY_BEAN: 'kidneybean',
  CLAY: 'clay',
  JAM: 'jam',
  BLUEBERGINE: 'bluebergine',
  GHOST_DARK: 'ghost-dark',
  GHOST_LIGHT: 'ghost-light'
};
exports.capsuleColours = capsuleColours;
var capsuleSizes = {
  SMALL: 'small'
};
exports.capsuleSizes = capsuleSizes;